(function () {
  'use strict';

  // ─── Slick: Multiple Items ───────────────────────────────────────────
  function initMultipleSlick() {
    if (!document.querySelector('.multiple-items')) return;
    $('.multiple-items').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
        { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ─── Slick: Single Items ─────────────────────────────────────────────
  function initSingleSlick() {
    if (!document.querySelector('.single-items')) return;
    $('.single-items').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000
    });
  }

  // ─── Slick: Product Detail ───────────────────────────────────────────
  function initProductSlick() {
    var $single = $('.slider-single');
    var $nav    = $('.slider-nav');
    if (!$single.length || !$nav.length) return;

    var slideCount = $nav.find('.small-img').length;

    $single.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
      infinite: slideCount > 1
    });

    $nav.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-single',
      dots: true,
      focusOnSelect: true,
      infinite: slideCount > 3,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768,  settings: { slidesToShow: 2 } },
        { breakpoint: 576,  settings: { slidesToShow: 2 } },
        { breakpoint: 420,  settings: { slidesToShow: 1 } }
      ]
    });
  }

  // ─── Bulk Page: Card Flip ────────────────────────────────────────────
  function initCardFlip() {
    if (!document.querySelector('.card')) return;
    $(document).on('click', '.card', function () {
      $(this).toggleClass('flip');
    });
  }

  // ─── Custom Slider (Our Story) ───────────────────────────────────────
  function initCustomSlider(sliderClass, speed) {
    var sliders = document.querySelectorAll(sliderClass);
    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll('.slide');
      if (!slides.length) return;
      var index = 0;
      slides[0].classList.add('active');
      setInterval(function () {
        slides[index].classList.remove('active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('active');
      }, speed);
    });
  }

  // ─── Smooth Scroll ───────────────────────────────────────────────────
  function initSmoothScroll() {
    if (window.location.pathname === '/' && window.location.hash) {
      var target = document.querySelector(window.location.hash);
      if (target) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500);
      }
    }

    document.querySelectorAll('a[href^="/#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = this.hash;
        if (window.location.pathname === '/') {
          e.preventDefault();
          var target = document.querySelector(hash);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ─── Boot ────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initMultipleSlick();
    initSingleSlick();
    initProductSlick();
    initCardFlip();
    initCustomSlider('.custom-slider', 2000);
    initCustomSlider('.left-slider', 3000);
    initCustomSlider('.right-slider', 3000);
    initSmoothScroll();
  });

})();
